module.exports = __webpack_public_path__ + "img/makeping-logo-dark.a3e77984.svg";